module.exports = __webpack_public_path__ + "img/find-a-matching-driver-for-your-led-module.70776394.png";